import './styles.css';

import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import type { IBaseCall, IBaseProps, Result } from 'bz-core-controls/modal-new/confirmation';
import ClickDialog from 'click-controls/controls/dialog';
import Button from 'click-controls/controls/form/button';
import React from 'react';
import ErrorPanel from '../error-panel';
import Actions from './controls/actions';

export interface IYesNoCall extends IBaseCall {
  yesLabel?: string;
  noLabel?: string;
  yesColor?: 'primary' | 'critical';
}

export type YesNoResult = Result.yes | Result.no;

export interface IYesNoDialogProps extends IBaseProps {
  disabled?: boolean;
  disabledYes?: boolean;
  disabledNo?: boolean;
  yesLabel?: string;
  noLabel?: string;
  yesColor?: 'primary' | 'critical';
  onYes: () => void;
  onNo: () => void;
}

class YesNoDialog extends React.Component<IYesNoDialogProps> {
  render() {
    const { className, hasErrors } = this;
    const {
      actionProps,
      contents,
      contentProps,
      dialogProps,
      disabled,
      disabledYes,
      disabledNo,
      errors,
      errorsTitle,
      open,
      title,
      titleProps,
      onErrorsOk,
      onErrorsCancel,
      onYes,
      onNo,
      yesColor,
      yesLabel,
      noLabel
    } = this.props;

    let actions;
    let errorPanel;
    if (hasErrors) {
      errorPanel = (
        <ErrorPanel
          className={this.props.className}
          errors={errors as string[]}
          title={errorsTitle}
          onOk={onErrorsOk}
          onCancel={onErrorsCancel}
        />
      );
    } else {
      actions = (
        <Actions
          className={className}
          disabled={disabled}
          disabledYes={disabledYes}
          disabledNo={disabledNo}
          actionProps={actionProps}
          yesLabel={yesLabel}
          noLabel={noLabel}
          yesColor={yesColor}
          onYes={onYes}
          onNo={onNo}
        />
      );
    }
    if (!!process.env.isClick) {
      return (
        <ClickDialog
          containerClass="max-h-full"
          bodyClass="max-h-96 overflow-y-auto"
          width="1/3 xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-1/2"
          isOpen={open}
          title={title}
          centered={true}
          closable={false}
          footer={
            <div className={'flex flex-wrap justify-end gap-3 pb-2 pt-6'}>
              <Button onPress={onYes} className={'btn'}>
                Yes
              </Button>
              <Button className={'btn'} onPress={onNo}>
                No
              </Button>
            </div>
          }
        >
          {contents}
          {errorPanel}
        </ClickDialog>
      );
    }
    return (
      <Dialog
        {...dialogProps}
        className={`${className} dialog`}
        classes={{ container: `${className} !items-center justify-center` }}
        open={open}
      >
        <DialogTitle {...titleProps} className={`${className} title`}>
          {title}
        </DialogTitle>
        <DialogContent {...contentProps} className={`${className} content`}>
          {contents}
          {errorPanel}
        </DialogContent>
        {actions}
      </Dialog>
    );
  }

  private get className(): string {
    const { className } = this.props;
    const classNames = ['bz-controls bz-modal yesno-dialog'];

    if (!!className) {
      classNames.push(className);
    }

    return classNames.join(' ');
  }

  private get hasErrors(): boolean {
    const { errors } = this.props;

    return !!errors && errors.length > 0;
  }
}

export default YesNoDialog;
